import { Plus, Settings } from "lucide-react";
import React from "react";

const PageHeader2 = ({
  children,
  title = "",
  text = [],
  buttonTitle = "",
  handleClick = () => { },
  showBtn2 = false,
  handleBtn2Click = () => { },
  disableBtn2 = true,
  buttonTitle2 = "",
  comingSoon = false,
  comingSoonText = "Coming Soon",
  buttonIcon = <></>,
}) => {
  return (
    <>
      <div className="space-y-6 text-center">
        <div>
          <h1 className="text-4xl font-bold text-green-600 transition duration-300 ease-in-out hover:text-green-800">
            {title}
          </h1>
          <div className="mt-4 space-y-2 text-gray-600">
            {text?.map((item, i) => (
              <p key={i}>{item}</p>
            ))}
          </div>
        </div>

        {comingSoon ? (
            <div className="flex flex-col gap-2 items-center justify-center">
            <div className="inline-block border-2 border-dashed border-gray-400 rounded-lg px-6 py-3">
            <span className="text-gray-600 font-medium">Coming Soon</span>
          </div>
          <div className="inline-block border-2 border border-gray-400 rounded-lg px-6 py-3 bg-green-100 cursor-pointer">
            <span className="text-gray-600 font-medium">{comingSoonText}</span>
          </div>
            </div>
          
        ) : buttonTitle ? (
          <div className="flex gap-2 items-center justify-center">
            <button
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
              onClick={() => handleClick()}
              title={buttonTitle}
            >
             {buttonIcon}
              {buttonTitle}
            </button>
            {showBtn2 ? (
              <button 
                className="bg-gray-600 hover:bg-gray-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-all shadow-md hover:shadow-lg transform hover:-translate-y-0.5"
                onClick={() => handleBtn2Click()}
                disabled={disableBtn2}
                title={buttonTitle2}
              >
                <Settings size={20} />
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
      {children}
    </>
  );
};

export default PageHeader2;